import React, { useState, useEffect, useMemo } from 'react';
import { DatePicker, CustomProvider } from 'rsuite';
import { injectIntl } from 'react-intl';
import '../../styles/rsuite.min.css';
import './BirthdayInput.css';
import { getDefaultLocale } from '../../util/genericHelpers';
import Icons from '../Icons/Icons';

import enGB from 'rsuite/locales/en_GB';
import deDE from 'rsuite/locales/de_DE';
import elGR from '../../lib/rsuiteLocales/el_GR';

const BirthdayInput = ({ onDateChange, initialValue, intl, disabled = false }) => {
  const [dateOfBirth, setDateOfBirth] = useState(initialValue || null);
  const [isOpen, setIsOpen] = useState(false);

  const appLocale = (getDefaultLocale?.() || intl?.locale || 'en').toLowerCase();
  const rsuiteLocale = appLocale === 'el' ? elGR : appLocale === 'de' ? deDE : enGB;

  const masks = useMemo(
    () => ({
      en: 'dd/MM/yyyy',
      el: 'ηη/μμ/εεεε',
      de: 'TT/MM/JJJJ',
    }),
    []
  );

  const intlPlaceholder = intl.formatMessage({ id: 'SignupForm.dateOfBirth' });
  const maskText = masks[appLocale] || masks.en;

  useEffect(() => {
    if (initialValue && !dateOfBirth) {
      setDateOfBirth(initialValue);
      onDateChange(initialValue);
    }
  }, [initialValue, dateOfBirth, onDateChange]);

  const handleDateChange = newDate => {
    setDateOfBirth(newDate);
    onDateChange(newDate);
  };

  const renderValue = value => {
    if (!value) return '';
    return value.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
  };

  const dynamicPlaceholder = isOpen ? maskText : intlPlaceholder;

  return (
    <CustomProvider locale={rsuiteLocale}>
      <div className="birthday-input-wrapper">
        <DatePicker
          oneTap
          format="dd/MM/yyyy"
          value={dateOfBirth}
          onChange={handleDateChange}
          disabled={disabled}
          placeholder={dynamicPlaceholder}
          cleanable={false}
          style={{ width: '100%' }}
          onOpen={() => setIsOpen(true)}
          onClose={() => setIsOpen(false)}
          onClean={() => setDateOfBirth(null)}
        />
        <div className="birthday-input-custom-icon">
          <Icons name="birthdayCalendar" />
        </div>
      </div>
    </CustomProvider>
  );
};

export default injectIntl(BirthdayInput);
